var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8279 20.7883L13.0475 16.4248C12.7188 16.2918 12.3599 16.5337 12.3599 16.8883V30.6678C12.3599 30.8752 12.488 31.0611 12.6819 31.135L23.4623 35.2419C23.7896 35.3665 24.1403 35.1248 24.1403 34.7746V21.2518C24.1403 21.0481 24.0168 20.8648 23.8279 20.7883Z",
    stroke: "#FEF335",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8657 16.6743L24.322 20.8428C24.2052 20.889 24.0752 20.8895 23.958 20.8442L13.1695 16.6759C12.7242 16.5039 12.7502 15.8653 13.208 15.73L23.997 12.5423C24.0905 12.5147 24.19 12.515 24.2833 12.5432L34.8266 15.7307C35.2801 15.8679 35.3064 16.5001 34.8657 16.6743Z",
    stroke: "#FEF335",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1401 34.7584V21.3151C24.1401 21.1123 24.2627 20.9295 24.4503 20.8525L35.2308 16.4295C35.5598 16.2945 35.9206 16.5365 35.9206 16.8921V30.3948C35.9206 30.5985 35.797 30.7819 35.6082 30.8583L24.8277 35.2218C24.499 35.3549 24.1401 35.113 24.1401 34.7584Z",
    stroke: "#FEF335",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.304b991a05e75368edda838a73a9afac.svg";
export { ForwardRef as ReactComponent };